<!-- profile picture -->
<app-user-header-image></app-user-header-image>

<!-- followers and connections -->

<div class="row py-4 mb-4">
  @if (repo.isSuperAdmin$ | async) {
    <div class="col d-grid">
      <app-impersonation-modal></app-impersonation-modal>
    </div>
  }
  <div class="col d-grid">
    <a
      routerLink="/profile/edit"
      class="btn btn-orange shadow-sm"
      i18n="Edit profile button"
      >{{ "editProfile" | transloco }}</a
      >
    </div>
  </div>
